import { initializeApp } from 'firebase/app'
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth'
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  collection,
  writeBatch,
  query,
  getDocs,
} from 'firebase/firestore'


const firebaseConfig = {
  apiKey: "AIzaSyADvwY62p-cn-jYF5avCfzATsZw1E3t-Do",
  authDomain: "toys-store-c1510.firebaseapp.com",
  projectId: "toys-store-c1510",
  storageBucket: "toys-store-c1510.appspot.com",
  messagingSenderId: "95136499795",
  appId: "1:95136499795:web:718b0c96816731b73b9ea6",
  measurementId: "G-S387YHBGLG"
};


const firebaseApp = initializeApp(firebaseConfig);


const provider = new GoogleAuthProvider();

provider.setCustomParameters({
  prompt: "select_account"

});

export const auth = getAuth();
export const signInWithGooglePopup = () => signInWithPopup(auth, provider)


export const db = getFirestore();

export const addCollectionAndDocuments=async (collectionKey,objectsToAdd)=>{
    const collectionRef=(collection(db,collectionKey));
    const batch= writeBatch(db);

    objectsToAdd.forEach((object)=>{
      const docRef=doc(collectionRef,object.title.toLowerCase());
      batch.set(docRef,object);


    })
    await batch.commit();
    console.log('done')

}

export const getCategoriesAndDocuments = async ()=>{
  const collectionRef=(collection(db,'categories'));
  const q=query(collectionRef)

  const querySnapshot= await getDocs(q);
  return querySnapshot.docs.map(docSnapshot=>docSnapshot.data());
  



}
export const createUserDocumentFromAuth = async (userAuth, additionalInformation = {}) => {
  if (!userAuth) return
  const userDocRef = doc(db, 'users', userAuth.uid)
  const userSnapshot = await getDoc(userDocRef)

  if (!userSnapshot.exists()) {
    const { displayName, email } = userAuth;
    const createdAt = new Date();
    try {
      await setDoc(userDocRef, {
        displayName,
        email,
        createdAt,
        ...additionalInformation
      });
    } catch (error) {
      console.log('error creating the user', error.message)
    }
  }

  return userSnapshot
}


export const createAuthUserWithEmailAndPassword = async (email, password) => {
  if (!email || !password) return;
  return await createUserWithEmailAndPassword(auth, email, password)
}

export const signInAuthUserWithEmailAndPassword = async (email, password) => {
  console.log('hadar');
  if (!email || !password) return;
  return await signInWithEmailAndPassword(auth, email, password)
}

export const signOutUser = async () => await signOut(auth);

export const onAuthStateChangedListener=(callback)=>
onAuthStateChanged(auth,callback);

export const getCurrentUser = () =>{
  return new Promise((resolve,reject)=>{
    const unsubcribe=onAuthStateChanged(
      auth,
      (userAuth)=>{
        unsubcribe();
        resolve(userAuth);
      },
      reject
    )
  })
}
